import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IUser } from "./getMe";
import type { IPagination, IPaginationParams } from "@/types/pagination";

// 사용자 목록 쿼리 파라미터 인터페이스
export interface IUserListParams extends IPaginationParams {
  role?: string;
  status?: string;
  grade?: number;
  school?: string;
  is_graduated?: boolean;
  search?: string;
  sort?: "grade" | "name" | "school";
  sort_order?: "asc" | "desc";
  group_id?: string;
}

/**
 * 사용자 목록을 조회하는 API 함수
 * @param params 쿼리 파라미터 (필터링, 페이징, 정렬)
 * @returns API 응답 객체
 */
export const apiGetUserList = async (params?: IUserListParams) => {
  // 요청 시 쿼리 파라미터로 정의된 값들만 전달
  const response = await apiGet<IPagination<IUser>>("/users", params);
  return response;
};

/**
 * 사용자 목록을 React Query를 통해 조회하는 훅
 * @param params 쿼리 파라미터 (필터링, 페이징, 정렬)
 * @param options React Query 옵션
 * @returns 쿼리 결과
 */
export const useQueryGetUserList = (params?: IUserListParams, options = {}) => {
  // 파라미터가 변경되면 쿼리 키가 변경되도록 파라미터를 쿼리 키에 포함
  const queryKey = QueryKeys.user.list(params);

  return useQuery({
    queryKey,
    queryFn: async () => {
      const response = await apiGetUserList(params);
      return response.data;
    },
    ...options,
  });
};

export default useQueryGetUserList;
